import { Navigate } from 'react-router-dom'

import { useAuth } from '@/hooks'
import { firstAppPath } from '@/utils/appHome'

import { TrackerMap } from './TrackerMap'
import { TrackerMapProvider } from './TrackerMapContext'

/** The tracker map. Gated like its nav link: `trackerMap`, or `preview`. */
export const TrackerMapPage: React.FC = () => {
  const { hasPermission } = useAuth()
  if (!hasPermission('preview') && !hasPermission('trackerMap')) {
    return <Navigate to={firstAppPath(hasPermission)} replace />
  }
  return (
    <TrackerMapProvider>
      <TrackerMap />
    </TrackerMapProvider>
  )
}
